// Shared by credential login and restored/live sessions; email verification is not required.
export const getAccountAccessError = profile => {
  if (!profile) return 'Tu perfil no existe. Contacta al administrador.';
  if (profile.registrationStatus === 'pending') return 'Tu registro está pendiente de aprobación. Podrás ingresar cuando el administrador habilite tu cuenta.';
  if (profile.registrationStatus === 'rejected') return 'Tu solicitud fue rechazada. Contacta al administrador.';
  if (profile.active !== true || !['company', 'admin'].includes(profile.role) || (profile.registrationStatus && profile.registrationStatus !== 'approved')) {
    return 'Tu acceso está desactivado. Contacta al administrador.';
  }
  return '';
};
